var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartAcc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1213_21237)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.6665 1.27783C10.9158 1.28951 10.1814 1.49907 9.53765 1.88535C8.89385 2.27162 8.36338 2.82094 7.99981 3.47783C7.63624 2.82094 7.10577 2.27162 6.46197 1.88535C5.81817 1.49907 5.08384 1.28951 4.33314 1.27783C3.13644 1.32983 2.00895 1.85333 1.197 2.73399C0.385049 3.61464 -0.0453576 4.78085 -0.000190567 5.97783C-0.000190567 9.00916 3.19048 12.3198 5.86648 14.5645C6.46395 15.0666 7.21938 15.3418 7.99981 15.3418C8.78024 15.3418 9.53566 15.0666 10.1331 14.5645C12.8091 12.3198 15.9998 9.00916 15.9998 5.97783C16.045 4.78085 15.6146 3.61464 14.8026 2.73399C13.9907 1.85333 12.8632 1.32983 11.6665 1.27783Z",
    fill: "#7266BA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1213_21237"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartAcc);
export default __webpack_public_path__ + "static/media/heart-acc.447aca335dd397841d283a3832dee77f.svg";
export { ForwardRef as ReactComponent };